export class Machine {
  public _id: string;
  public active: boolean;
  public image: string;
  public number: string;
  public notes: string;
  public serial: string;
  public price: string;
  public manufactureYear: string;
  public supplyDate: Date;
  public vbelt: string;
  public vbeltPrice: string;
  public airfilter: string;
  public airfilterPrice: string;
  public oilfilter: string;
  public oilfilterPrice: string;
  public seperatorelem: string;
  public seperatorelemPrice: string;
  public pressureswitch: string;
  public pressureswitchPrice: string;
  public compressortype: string;
  public filterelem: string;
  public filterelemprice: string;
  public vermogen: string;
  public spanning: string;
  public ponbelast: string;
  public deltap: string;
  public customer: any;
  public currentMachineMaintenance: any;

  constructor(public name: string, public type: string) {}
}



// WEBPACK FOOTER //
// ./src/app/models/machine.model.ts